import { SkyscannerPlace } from './avia';

export namespace Suggest {
  export function instanceOfCar(object: any): object is Suggest.CarsSuggest {
    return 'printname' in object;
  }

  export enum Type {
    HOTEL,
    CAR,
    FLIGHT,
  }

  export enum Ids {
    HOTEL = 'hotel',
    GEO = 'geo',
    CAR_PICK = 'car_pick',
    CAR_DROP = 'car_drop',
    FLIGHT_FROM = 'flight_from',
    FLIGHT_TO = 'flight_to',
  }

  export interface Request {
    hotels_limit: number;
    q?: string;
    geo?: string;
  }

  export interface Geo {
    city_id: string;
    city: string;
    country_title?: string;
    country?: string;
    state?: string;
  }

  export interface HotelSuggests {
    data: HotelSuggest[];
  }

  export interface HotelSuggest {
    id: string;
    geo?: Geo;
    type: string;
    title?: string;
    sub_title?: string;
    lat?: number;
    lon?: number;
    language?: string;
  }

  export interface Geo {
    city: string;
    country_title?: string;
    state?: string;
    country?: string;
  }

  export interface Rating {
    rating?: string;
    count?: number;
    max?: string;
    text?: string;
    reviews?: number;
  }

  export interface Query {
    text: string;
    type: QueryType;
  }

  export enum QueryType {
    AUTO,
    TYPE,
  }

  export interface CarsSuggests {
    data: CarsSuggest[];
  }

  export interface CarsSuggest {
    id: number;
    iata?: string;
    type: string;
    name: string;
    parentName?: string;
    w: number;
  }

  export interface FlightSuggest extends SkyscannerPlace {
    id?: string;
  }

  export type TypedSuggest = CarsSuggest | HotelSuggest | FlightSuggest;

  export interface Suggest<T extends TypedSuggest> {
    source: T;
    title?: string;
    subtitle?: string;
    locationType?: LocationType;
  }

  export enum LocationType {
    POINT,
    CITY,
    AIRPORT,
    HOTEL,
    UNKONWN,
    STATION,
  }

  export interface SelectedSuggest {
    suggest: Suggest<TypedSuggest>;
    inputId: Ids;
    hoveredIndex: number;
  }

  export class SuggestContainer<T extends TypedSuggest> {
    inputId: Suggest.Ids;
    query: Query = { text: '', type: QueryType.TYPE };
    selected: Suggest<T> = null;
    suggests: Suggest<T>[] = [];
    error: string = '';
    loading: boolean = false;

    constructor({
      id,
      query,
      suggest,
      error,
      suggests,
      loading,
    }: {
      id: Suggest.Ids;
      query?: Query;
      suggest?: Suggest<T>;
      suggests?: Suggest<T>[];
      error?: string;
      loading?: boolean;
    }) {
      this.inputId = id;
      if (query) {
        this.query = query;
      }
      if (suggest) {
        this.selected = suggest;
      }
    }

    clear() {
      this.query.text = '';
      this.query.type = Suggest.QueryType.TYPE;
      // this.suggests = [];
      // this.selected = null;
      this.loading = false;
      this.error = '';
    }

    reset() {
      this.suggests = [];
      this.selected = null;
      this.query.text = '';
      this.query.type = Suggest.QueryType.TYPE;
      this.error = '';
    }
  }
}
